import clsx from "clsx";

export type RentalStockTabProps = {
  children?: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
};

export const RentalStockTab = ({
  children,
  active,
  onClick,
}: RentalStockTabProps) => {
  return (
    <div className="flex flex-col gap-3" onClick={onClick}>
      <div
        className={clsx([
          "min-w-[80px] flex justify-center items-center text-base leading-[17px]",
          {
            "font-semibold text-black": active,
            "font-normal text-brand-neutral-40": !active,
          },
        ])}
      >
        {children}
      </div>
      <div
        className={clsx([
          "w-full bg-brand-floating-primary-button h-[3px] transition-all",
          {
            "opacity-100": active,
            "opacity-0": !active,
          },
        ])}
      ></div>
    </div>
  );
};
